import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PayuPaymentService {
  private paymentsUrl = `${environment.payments}`;

  constructor(private _http: HttpClient) { }

  createPayUPayment(data: any, isPayUPaymentRequired: boolean): Observable<string> {
    return this._http.post<any>(`${this.paymentsUrl}/SubmitPayUPayment/${isPayUPaymentRequired}`, data, { responseType: 'text' as 'json' });
  }

  addOrUpdatePayUPayment(data: any): Observable<string> {
    return this._http.put<any>(`${this.paymentsUrl}/AddOrUpdatePayUPaymentRequest`, data);
  }


  getPaymentUrl() {
    return `${this.paymentsUrl}/CreatePayment`;
  }

  getPaymentTransaction(id: any): Observable<any> {
    return this._http.get(`${this.paymentsUrl}/GetPayUPaymentTransaction/${id}`);
  }

  getAllPaymentHistory(orgId: any, pageNumber: any, pageSize: any, searchValue: any, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20,
      search: searchValue,
      filters: filters
    }
    return this._http.get<any>(`${this.paymentsUrl}/GetPayUPaymentTransactionsByOrgId/${orgId}`)
  }

  getPayUInvoiceTemplateHtml(invoiceId: any, organizationId: any): Observable<any> {
    return this._http.get<any>(`${this.paymentsUrl}/GetPayUInvoiceHTML/${organizationId}/${invoiceId}`, { responseType: 'text' as 'json' })
  }

  getPendingPayUTransaction(orgId: any): Observable<any> {
    return this._http.get(`${this.paymentsUrl}/GetPayUPendingPaymentsForOrg/${orgId}`);
  }

}
